import { signal, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { Profile } from '@/app/api/profile';

@Injectable({
  providedIn: 'root',
})
export class AuthStore {
  private _user = signal<Profile | null>(null);

  get authUser() {
    return this._user.asReadonly();
  }

  get authUser$() {
    return toObservable(this.authUser);
  }

  setAuthUser(user: any | null) {
    this._user.set(user);
    localStorage.setItem('authUser', JSON.stringify(user));
  }
}
